module.exports = __webpack_public_path__ + "static/media/Fidelity National Financial Logo.7fed9519.jpeg";